import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'

import { get, put } from '@/lib/api'

import { teamKeys } from './use-teams'

// ==================== Types ====================

export interface TeamStageOwners {
  id: string
  teamId: string
  uiDesignOwnerId: string | null
  frontendOwnerId: string | null
  backendOwnerId: string | null
  testingOwnerId: string | null
  createdAt: string
  updatedAt: string | null
}

export interface UpdateTeamStageOwnersInput {
  uiDesignOwnerId?: string | null
  frontendOwnerId?: string | null
  backendOwnerId?: string | null
  testingOwnerId?: string | null
}

// ==================== Query Keys ====================

export const teamStageOwnerKeys = {
  all: ['team-stage-owners'] as const,
  detail: (teamId: string) => [...teamStageOwnerKeys.all, teamId] as const,
}

// ==================== Hooks ====================

/**
 * 获取团队阶段负责人配置
 */
export function useTeamStageOwners(teamId: string) {
  return useQuery({
    queryKey: teamStageOwnerKeys.detail(teamId),
    queryFn: () => get<TeamStageOwners | null>(`/teams/${teamId}/stage-owners`),
    enabled: !!teamId,
  })
}

/**
 * 更新团队阶段负责人配置
 */
export function useUpdateTeamStageOwners() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ teamId, data }: { teamId: string; data: UpdateTeamStageOwnersInput }) =>
      put<TeamStageOwners>(`/teams/${teamId}/stage-owners`, data),
    onSuccess: (_, { teamId }) => {
      void queryClient.invalidateQueries({ queryKey: teamStageOwnerKeys.detail(teamId) })
      void queryClient.invalidateQueries({ queryKey: teamKeys.detail(teamId) })
    },
  })
}
